import React, { useEffect, useState, createRef } from 'react';
import {
	Row,
	Col,
	Card,
	CardBody,
	CardTitle,
	CardText,
	Badge,
	UncontrolledTooltip,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	Label,
} from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import { bindActionCreators } from 'redux';
import { connect, useDispatch } from 'react-redux';
import RastreabilidadeContainer from '@common/rastreabilidade/rastreabilidade.container';
import InfiniteScroll from 'react-infinite-scroller';
import { Editor } from 'vivace-fluent-motion';
import ModalComponentAsync from '@componentes/modal/modal.async';
import MorfologiaContainer from '@common/morfologia/morfologia.container';
import ConfirmacaoSelect from '@componentes/cancelamento/ConfirmacaoSelect';
import CancelamentoComponent from '@componentes/cancelamento/cancelamento.component';
import {
	statusEtapasEnum,
	etapasEnum,
	retornaStatusFormatado,
	retornaEtapaFormatada,
} from '@common/util/defaultValues';
import * as commonActionsReducer from '../../../app/common/common.action';
import WebapiCommon from '../../../app/common/util/webapi.common';

import { acessoPermitido } from '../../../acessos.seguranca';
import ConfiguracaoApi from '../../configuracao/configuracao.api';
import * as modalLiberacaoParcialmenteAction from '../../laudo/modais/liberacao_parcial/store/liberacao.action';
import * as modalLiberarLaudoAction from '../../laudo/modais/liberacao_total/store/liberacaoTotal.action';
import LaudoApi from '../../laudo/laudo.api';
import * as acessos from '../../../acessos.const.util';
import './listagem.common.styles.css';
import ListagemActionsComponent from './listagem.actions.component';
import ModalEntregaContainer from './modais/entrega/modal.entrega.container';
import ModalFaturamentoContainer from './modais/faturamento/modal.faturamento.container';
import ModalImprimirContainer from './modais/imprimir_laudo/modal.imprimir.container';
import ModalObservacoesContainer from './modais/observacoes/modal.observacoes.container';
import EtiquetaContainer from '../../laudo/etapas/material/tabs/etiqueta/etiqueta.container';
import RequisicaoImunoModal from './modais/requisicaoimuno/requisicao.imuno.modal';
import RequisicaoCongelacaoModal from './modais/requisicaocongelacao/requisicao.congelacao.modal';
import InformacoesLaudoModal from './modais/informacoes_laudo/informacoes.laudo.modal';
import ModalLiberacaoParcial from '../../laudo/modais/liberacao_parcial';
import ModalLiberacaoTotal from '../../laudo/modais/liberacao_total';
import ControleBlocosLaminas from '../ControleBlocosLaminas';
import NomeSocial from '@containers/NomeSocial';
import IconInfoCard from '@containers/IconInfoCard';
import { calcIdade, mapGenero } from '../../../functions/general';
import * as certificacaoActionsReducer from '@common/certificacao/certificacao.action';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { httpRequest } from '@util/api-common.util';

const refModalCid = createRef();
const MODAL_FECHADO = true;

function ListagemCommonContainer({
	history,
	commonActions,
	certificacaoActions,
	modalLiberarParcialmenteAction,
	modalLiberarParcialmente,
	loadListagem,
	listagemExibido,
	listagemTotal,
	listagem,
	actions,
	pagina,
	detalhes,
	altura,
	usuario,
	modalCertificacao,
	modalEntrega,
	modalFaturamento,
	modalObservacoes,
	modalImprimir,
	modalRequisicaoImuno,
}) {
	const dispatch = useDispatch();
	const [avisoCertificacao, setAvisoCertificacao] = useState(false);
	const [avisoCertificacaoLiberacao, setAvisoCertificacaoLiberacao] =
		useState(false);
	const [modalEtiquetas, setModalEtiquetas] = useState(false);
	const [detalhesLaudo, setDetalhesLaudo] = useState(undefined);
	const [frascos, setFrascos] = useState(undefined);
	const [modalcommon, setModalcommon] = useState(false);
	const [modalrastreabilidade, setModalrastreabilidade] = useState(false);
	const [showModalRequisicaoCongelacao, setShowModalRequisicaoCongelacao] =
		useState(false);
	const [labelNotas, setLabelNotas] = useState('NOTAS');
	const [laudo, setLaudo] = useState(undefined);
	const [modalEmail, setModalEmail] = useState(false);
	const [modalInfoLaudo, setModalInfoLaudo] = useState(false);
	const [email, setEmail] = useState('');
	const [assuntoEmail, setAssuntoEmail] = useState('');
	const [corpoEmail, setCorpoEmail] = useState('');
	const [showModalControle, setShowModalControle] = useState(false);
	const [modalSize, setModalSize] = useState('');
	const [modalTitulo, setModalTitulo] = useState('');
	const [modalEncaminhar, setModalEncaminhar] = useState(false);
	const [modalEncaminharType, setModalEncaminharType] = useState('ok');
	const intl = useIntl();

	const [isModalCancelamentoEtapaOpen, setIsModalCancelamentoEtapaOpen] =
		useState(false);
	const [
		isModalCancelamentoJustificativaOpen,
		setIsModalCancelamentoJustificativaOpen,
	] = useState(false);
	const [justificativaCancelarEtapas, setJustificativaCancelarEtapas] =
		useState('');
	const [etapaSelecionada, setEtapaSelecionada] = useState('');
	const [habilitadoCertificacao, setHabilitadoCertificacao] = useState();
	const [tempList, setTempList] = useState();

	const hasHabilitado = () => {
		ConfiguracaoApi.getConfigCertificacaoDigital().then((res) => {
			setHabilitadoCertificacao(res.certificacao_Habilitar);
		});
	};

	function getTranslate(key) {
		return intl.formatMessage({ id: key });
	}

	useEffect(() => {
		hasHabilitado();
	});

	useEffect(() => {
		if (detalhes) {
			WebapiCommon.getDetalhes(detalhes.laudo).then((res) => {
				setDetalhesLaudo(res);
				commonActions.atualizarNumeroExameDoLaudoNaListagem(
					res.laudo,
					res.nrExame
				  );
			})
		}
	},[]);

	useEffect(() => {
		ConfiguracaoApi.getConfiguracaoGeral().then((res) => {
			setLabelNotas(res.nomeExibicaoEtapaNotas.toUpperCase());
		});
		modalLiberarParcialmenteAction.obterConfiguraco();
	}, []);

	useEffect(() => {
		tempList && !modalCertificacao && liberarLaudo(tempList);
	}, [tempList, modalCertificacao]);

	const handleLoadListagem = () => {
		if (!loadListagem) {
			if (listagemExibido < listagemTotal) {
				commonActions.loadListagem(true);
				commonActions.avancarPaginaListagem(pagina + 1);
			}
		}
	};

	const ativo = detalhes ? detalhes.laudo : undefined;

	const getAltura = () => `${window.innerHeight - altura - 160}px`;

	const verificarObrigatoriedadeCIDs = (item) =>
		new Promise((resolve) => {
			setTimeout(() => {
				// Validar obrigatoriedade de CIDs para laudos críticos.
				handleModalCID(item.laudo).then((statusModal) => {
					WebapiCommon.getCIDPorLaudo(item.laudo).then((response) => {
						if (response.length <= 0)
							resolve(
								'Solicitação de liberação cancelada. Obrigatório cadastro de CID para este laudo.'
							);

						resolve(statusModal);
					});
					certificado;
				});
			}, 300);
		});

	const tiposLiberarLaudo = (item) =>
		new Promise((resolve) => {
			const { liberacaoParcialHabilitada } = modalLiberarParcialmente;
			/* item.certificado
			!avisoCertificacaoLiberacao */
			const liberarLaudoTotalmente = true;

			if (item.isLiberadoParcial && !item.isLiberadoTotal) {
				// chamar o modal de liberação total passando o laudo para o estado
				modalLiberarParcialmenteAction.fecharModal(
					liberarLaudoTotalmente,
					liberacaoParcialHabilitada,
					item.laudo
				);
			} else if (!item.isLiberadoParcial && !item.isLiberadoTotal) {
				// chamo o modal para liberação parcial
				modalLiberarParcialmenteAction.fecharModal(
					!liberarLaudoTotalmente,
					liberacaoParcialHabilitada,
					item.laudo
				);
			}
			resolve();
		});

	const liberarLaudo = async (item) => {
		if (
			habilitadoCertificacao &&
			!avisoCertificacaoLiberacao &&
			item &&
			!item.certificado &&
			/* props.detalhes.habilitadoCertificacao && */
			acessoPermitido(usuario, acessos.CertificacaoDigital)
		) {
			certificacaoActions.certificadosSelecionados([item.laudo]);
			certificacaoActions.showModal(true);
			setTempList(item);
			return setAvisoCertificacaoLiberacao(true);
		}

		if (item && item.critico) {
			WebapiCommon.getCIDPorLaudo(item.laudo).then((response) => {
				if (response.length <= 0) {
					verificarObrigatoriedadeCIDs(item).then((statusModal) => {
						if (statusModal === true) {
							modalLiberarParcialmenteAction.obterConfiguraco();
							tiposLiberarLaudo(item);
						} else {
							commonActions.showAlerta('alerta', statusModal, 5000, '750px');
						}
					});
				} else {
					modalLiberarParcialmenteAction.obterConfiguraco();
					tiposLiberarLaudo(item);
				}
			});
		} else {
			modalLiberarParcialmenteAction.obterConfiguraco();
			tiposLiberarLaudo(item);
		}
		setTempList();
	};

	const openModalEntrega = (item) => {
		commonActions.mudarStatusModalEntrega(true, item);
	};

	const onItemClick = (item) => {
		const { laudo: laudoItem } = item;
		history.push(`/laudo/${laudoItem}`);
	};

	const encaminharSegundaOpiniao = () => {
		setModalEncaminhar(!modalEncaminhar);
	};

	const fecharModalEncaminhar = () => {
		setModalEncaminhar(!modalEncaminhar);
	};

	const toggleModalEmail = (laudoSelecionado) => {
		if (laudoSelecionado && typeof laudoSelecionado !== 'object') {
			commonActions.showFadeCarregando(true);

			WebapiCommon.getEmail(laudoSelecionado)
				.then((res) => {
					setModalEmail(!modalEmail);
					setLaudo(laudoSelecionado);
					setAssuntoEmail(res.data.assunto);
					setEmail(res.data.destinatario);

					commonActions.showFadeCarregando(false);
				})
				.catch(() => {
					commonActions.showFadeCarregando(false);
				});
		} else {
			setModalEmail(!modalEmail);
		}
	};

	const toggleModalInfoLaudo = (laudoSelecionado) => {
		if (laudoSelecionado && typeof laudoSelecionado !== 'object') {
			commonActions.showFadeCarregando(true);

			WebapiCommon.getDetalhes(laudoSelecionado)
				.then((res) => {
					setLaudo(laudoSelecionado);
					setDetalhesLaudo(res);
					WebapiCommon.getFrascos(laudoSelecionado).then((frascos)=>{
						commonActions.showFadeCarregando(false);
						setFrascos(frascos);
						setModalInfoLaudo(!modalInfoLaudo);
					})
				})
				.catch(() => {
					commonActions.showFadeCarregando(false);
				});
		} else {
			setModalInfoLaudo(false);
		}
	};

	const sendEmail = (e, laudoAtual) => {
		e.preventDefault();

		const payload = {
			mensagem: corpoEmail,
			laudo: laudoAtual,
			destinatario: email,
			assunto: assuntoEmail,
		};

		commonActions.showFadeCarregando(true);

		WebapiCommon.sendEmail(payload)
			.then(() => {
				const mensagem = 'Email enviado com sucesso';

				commonActions.showAlerta(
					'sucesso',
					mensagem,
					2000,
					`${mensagem.length * 10}px`
				);
				commonActions.showFadeCarregando(false);
				toggleModalEmail();
			})
			.catch(() => {
				const mensagem = 'Houve um erro ao enviar o email';

				commonActions.showAlerta(
					'erro',
					mensagem,
					2000,
					`${mensagem.length * 10}px`
				);

				commonActions.showFadeCarregando(false);
			});
	};

	const getQuantidadeLaudosAnteriores = (prontuario) => {
		WebapiCommon.getLaudosAnterioresQuantidade(prontuario).then((result) => {
			dispatch(commonActions.preenhcerTotalLaudosAnteriores(result));
		});
	};

	const getQuantidadeLaudosEmAberto = (prontuario, laudo) => {
		WebapiCommon.getTotalExamesEmAberto(prontuario, laudo).then((result) => {
			dispatch(commonActions.preencherTotalLaudosEmAberto(result));
		});
	};

	const getLaudoDetalhes = (item) => {
		const {
			laudo: laudoItem,
			prontuario,
			etapas,
			exame,
			nenhumaEtapaAplicavel,
		} = item;

		if (nenhumaEtapaAplicavel) {
			const msg = `O tipo de exame ${exame} não possui nenhuma etapa aplicável`;
			const tamanho = `${msg.length * 10}px`;
			dispatch(commonActions.showAlerta('alerta', msg, 3500, tamanho));
		} else {
			WebapiCommon.getDetalhes(laudoItem).then((response) => {
				dispatch(
					commonActions.atualizarLaudoSelecionado({
						laudoItem,
						prontuario,
						exame,
					})
				);
				getQuantidadeLaudosAnteriores(prontuario);
				getQuantidadeLaudosEmAberto(prontuario, laudo);
				dispatch(commonActions.atualizarDetalhes({ ...response, etapas }));
				WebapiCommon.getHistoricoNaoConformidades(response.laudo).then(
					(result) =>
						dispatch(commonActions.preenhcerHistoricoInconformidades(result))
				);
			});
		}
	};

	const showModalCID = async () =>
		new Promise((resolve, reject) => {
			setTimeout(async () => {
				const modal = refModalCid.current;
				try {
					await modal.show();
				} catch (err) {
					reject(err);
				}
				resolve(MODAL_FECHADO); // Significa que o modal foi fechado
			}, 100);
		});

	const handleModalCancelamento = async (laudoSelecionado) =>
		new Promise(() => {
			LaudoApi.getLaudo(laudoSelecionado)
				.then((response) => {
					if (response) {
						const { listagem: listagemAtual } = response;

						if (listagemAtual && listagemAtual.length) {
							const [laudoAtual] = listagemAtual;

							getLaudoDetalhes(laudoAtual);
							dispatch(commonActions.atualizarDetalhes(laudoAtual));
						}
					}
				})
				.then(() => setIsModalCancelamentoEtapaOpen(true));
		});

	const cancelarEtapasPosteriores = () => {
		commonActions.showFadeCarregando(true);
		if (etapaSelecionada === 'LIBERADO') {
			httpRequest(`Laudos/${detalhes.laudo}/cancelar-liberacao`, 'PATCH', detalhes.solicitante).then((res) => {
				setJustificativaCancelarEtapas('');
				const lista = [...listagem];
				const listaIndex = lista.findIndex(item => item.laudo === detalhes.laudo);

				if(listaIndex >= 0) {
					lista[listaIndex].dataLiberacao = '';
					lista[listaIndex].isLaudoLiberado = false;
					lista[listaIndex].isLiberadoTotal = false;
					dispatch(commonActions.preencherListagem(lista));
				}

				if (res.success) {
					commonActions.showAlerta('sucesso', res.message, 2000);

					WebapiCommon.getDetalhes(detalhes.laudo).then((detalhes) => {
						dispatch(commonActions.atualizarDetalhes(detalhes));
						dispatch(commonActions.atualizarNumeroExameDoLaudoNaListagem(detalhes.laudo, detalhes.nrExame));
					});

					WebapiCommon.obterStatusEtapasLaudo(detalhes.laudo).then(
						(etapas) => {
							dispatch(commonActions.atualizarStatusDasEtapasDoLaudo(etapas, detalhes.laudo));
							dispatch(commonActions.showFadeCarregando(false));
						}
					);
				}
			})
			.catch((err) => {
				setJustificativaCancelarEtapas('');
				commonActions.showFadeCarregando(false);
				if (err) {
					commonActions.showAlerta('erro', err.data, 2000);
				} else {
					commonActions.showAlerta('erro', <IntlMessage id="dashboards.examDetail.unableCancelSteps" />, 2000);
				}
			})
			.finally(() => {
				setIsModalCancelamentoEtapaOpen(false);
				setIsModalCancelamentoJustificativaOpen(false);
			});
		} else {
			WebapiCommon.cancelarEtapasPosteriores(
				detalhes.laudo,
				etapaSelecionada,
				0,
				justificativaCancelarEtapas
			)
				.then((response) => {
					setJustificativaCancelarEtapas('');
					if (response.success) {
						commonActions.showAlerta('sucesso', response.data.mensagem, 2000);
						WebapiCommon.getDetalhes(detalhes.laudo).then(
							(d) => {
								commonActions.atualizarStatusDasEtapasDoLaudo(
									d.etapas,
									detalhes.laudo
								);
								commonActions.atualizarDetalhes(d);
								commonActions.atualizarNumeroExameDoLaudoNaListagem(
									detalhes.laudo,
									d.nrExame
								  );
								commonActions.showFadeCarregando(false);
							}
						);
					}
				})
				.catch((error) => {
					setJustificativaCancelarEtapas('');
					console.log(error);
					commonActions.showFadeCarregando(false);
					if (error) {
						commonActions.showAlerta('erro', error.data, 2000);
					} else {
						commonActions.showAlerta(
							'erro',
							<IntlMessage id="dashboards.examDetail.unableCancelSteps" />,
							2000
						);
					}
				})
				.finally(() => {
					setIsModalCancelamentoEtapaOpen(false);
					setIsModalCancelamentoJustificativaOpen(false);
				});
		}
	};

	const handleModalCID = async (laudoSelecionado) =>
		new Promise((resolve) => {
			LaudoApi.getLaudo(laudoSelecionado)
				.then((response) => {
					if (response) {
						const { listagem: listagemAtual } = response;

						if (listagemAtual && listagemAtual.length) {
							const [laudoAtual] = listagemAtual;

							setModalTitulo(
								<IntlMessage id="dashboards.examDetail.mandatoryCID" />,
								`${laudoAtual.laudo}`
							);
							getLaudoDetalhes(laudoAtual);
							dispatch(commonActions.atualizarDetalhes(laudoAtual));
							setModalSize('lg');
						}
					}
				})
				.then(() =>
					showModalCID().then((res) => {
						resolve(res);
					})
				);
		});

	const toggleModal = async (
		nomeComponente,
		laudoSelecionado,
		prontuario,
		exame
	) => {
		if (modalcommon) {
			setModalcommon(false);
		}
		switch (nomeComponente) {
			case 'rastreabilidade':
				commonActions.showFadeCarregando(true);

				WebapiCommon.obterListagemRastreabilidade(laudoSelecionado).then(
					(response) => {
						commonActions.showFadeCarregando(false);
						commonActions.atualizarListagemRastreabilidade(response);
						setModalcommon(!modalcommon);
						setModalrastreabilidade(true);
					}
				);
				break;

			case 'controle_bloco_lamina':
				setShowModalControle(true);
				setLaudo(laudoSelecionado);
				break;
			default:
				break;
		}
	};

	const toggleModalEtiquetas = (item) => {
		if (item && !modalEtiquetas) {
			Promise.all([
				WebapiCommon.getDetalhes(item.laudo),
				WebapiCommon.getFrascos(item.laudo),
			]).then((response) => {
				commonActions.adicionarFrasco(response[1]);
				setDetalhesLaudo(response[0]);
				setModalEtiquetas(!modalEtiquetas);
			});
		} else {
			setModalEtiquetas(!modalEtiquetas);
		}
	};

	const toggleModalImprimir = (item) => {
		commonActions.mudarStatusModalImprimir(true, item);
	};

	const toggleModalObservacoes = (item) => {
		commonActions.mudarStatusModalObservacoes(true, item);
	};

	const toggleModalRequisicaoCongelacao = (laudoSelecionado) => {
		setLaudo(laudoSelecionado);
		setShowModalRequisicaoCongelacao(!showModalRequisicaoCongelacao);
	};

	const toggleModalRequisicaoImuno = (laudoSelecionado) =>
		commonActions.mudarStatusModalImuno(laudoSelecionado);

	const rastreabilidadeAltura = getAltura();

	return (
		<Col className="listagem-exames">
			<ControleBlocosLaminas
				laudo={laudo}
				showModalControle={showModalControle}
				onModal={() => {
					setShowModalControle(!showModalControle);
				}}
			/>
			{modalEntrega && <ModalEntregaContainer altura={rastreabilidadeAltura} />}
			{modalImprimir && (
				<ModalImprimirContainer altura={rastreabilidadeAltura} />
			)}
			{modalObservacoes && (
				<ModalObservacoesContainer altura={rastreabilidadeAltura} />
			)}

			<ModalFaturamentoContainer altura={rastreabilidadeAltura} />

			<ModalComponentAsync
				size={modalSize}
				titulo={modalTitulo}
				ref={refModalCid}
			>
				<MorfologiaContainer altura={window.innerHeight - 215} />
			</ModalComponentAsync>

			{isModalCancelamentoEtapaOpen && (
				<ConfirmacaoSelect
					isOpen={isModalCancelamentoEtapaOpen}
					toggle={() =>
						setIsModalCancelamentoEtapaOpen(!isModalCancelamentoEtapaOpen)
					}
					shoModalJustificativa={() =>
						setIsModalCancelamentoJustificativaOpen(true)
					}
					etapaSelecionada={etapaSelecionada}
					setEtapaSelecionada={setEtapaSelecionada}
				/>
			)}

			<ModalEncaminhar
				toggleModalEncaminhar={() => encaminharSegundaOpiniao(!modalEncaminhar)}
				type={modalEncaminharType}
				showModalEncaminhar={modalEncaminhar}
				titulo={'Encaminhar'}
				mensagem={'Encaminhar'}
				confirmar={() => fecharModalEncaminhar()}
				laudo={laudo}
				commonActions={commonActions}
			/>

			<CancelamentoComponent
				isOpen={isModalCancelamentoJustificativaOpen}
				toggle={() => {
					setIsModalCancelamentoJustificativaOpen(false)
					setJustificativaCancelarEtapas('')
				}}
				setJustificativa={(texto) => setJustificativaCancelarEtapas(texto)}
				justificativaCancelar={justificativaCancelarEtapas}
				cancelarEtapa={cancelarEtapasPosteriores}
			/>

			{modalEtiquetas && (
				<Modal size="lg" isOpen={modalEtiquetas} toggle={toggleModalEtiquetas}>
					<ModalHeader toggle={toggleModalEtiquetas}>
						<p>
							<IntlMessage id="dashboards.examDetail.label" />
						</p>
					</ModalHeader>
					<ModalBody>
						<EtiquetaContainer
							toggle={toggleModalEtiquetas}
							altura={rastreabilidadeAltura}
							callbackClose={toggleModalEtiquetas}
							detalhes={detalhesLaudo}
						/>
					</ModalBody>
				</Modal>
			)}
			{modalRequisicaoImuno && (
				<RequisicaoImunoModal
					isOpen={modalRequisicaoImuno}
					toggle={toggleModalRequisicaoImuno}
				/>
			)}

			{showModalRequisicaoCongelacao && (
				<RequisicaoCongelacaoModal
					isOpen={showModalRequisicaoCongelacao}
					toggle={toggleModalRequisicaoCongelacao}
					laudo={laudo}
				/>
			)}

			{modalInfoLaudo && (
				<InformacoesLaudoModal
					isOpen={modalInfoLaudo}
					toggle={toggleModalInfoLaudo}
					laudo={laudo}
					detalhesLaudo={detalhesLaudo}
					frascos={frascos}
				/>
			)}

			<ModalLiberacaoParcial />
			<ModalLiberacaoTotal />

			<Modal size="lg" isOpen={modalcommon} toggle={toggleModal}>
				<ModalHeader toggle={toggleModal}>
					{modalrastreabilidade && (
						<p>
							<IntlMessage id="dashboards.examDetails.traceability" />
						</p>
					)}
				</ModalHeader>
				<ModalBody>
					{modalrastreabilidade && (
						<RastreabilidadeContainer altura={rastreabilidadeAltura} />
					)}
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleModal}>
						<IntlMessage id="dashboards.examDetails.cancel" />
					</Button>
				</ModalFooter>
			</Modal>

			<Modal size="lg" isOpen={modalEmail} toggle={toggleModalEmail}>
				<form onSubmit={(e) => sendEmail(e, laudo)}>
					<ModalHeader toggle={toggleModalEmail}>
						<IntlMessage id="dashboards.examDetail.sendReportEmail" /> {laudo}
					</ModalHeader>
					<ModalBody>
						<Row>
							<Col xl={12}>
								<FormGroup>
									<Label>
										<IntlMessage id="dashboards.examDetail.recipient" />
									</Label>
									<Input
										type="email"
										required
										placeholder={getTranslate(
											'dashboards.examDetail.recipientEmail'
										)}
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
								</FormGroup>
							</Col>
							<Col xl={12}>
								<FormGroup>
									<Label>
										<IntlMessage id="dashboards.examDetail.subject" />
									</Label>
									<Input
										required
										minLength={10}
										placeholder={getTranslate(
											'dashboards.examDetail.subjectEmail'
										)}
										value={assuntoEmail}
										onChange={(e) => setAssuntoEmail(e.target.value)}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Editor
							placeholder={getTranslate('dashboards.examDetail.enterText')}
							height="300px"
							onHtml={(val) => setCorpoEmail(val)}
							value={corpoEmail}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" type="submit">
							<IntlMessage id="dashboards.examDetails.sendEmail" />
						</Button>
						<Button color="secondary" onClick={toggleModalEmail}>
							<IntlMessage id="dashboards.examDetails.cancel" />
						</Button>
					</ModalFooter>
				</form>
			</Modal>
			<div className="mv-listagem-container" style={{}}>
				{!listagemExibido && (
					<Col className="mv-listagem-container no-result">
						<i className="mv-basico-pesquisar" /> <br />
						<IntlMessage id="dashboards.general.noFilteredItems" />
					</Col>
				)}
				{!!listagemExibido && !!listagem.length && (
					<InfiniteScroll
						pageStart={0}
						loadMore={handleLoadListagem}
						hasMore={listagemExibido < listagemTotal}
						useWindow={false}
					>
						<div id="listagem-exames" style={{paddingLeft: '10px', paddingRight: '10px'}}>
							{listagem.map((item) => {
								let cardClass = `${item.laudo === ativo ? 'ativo ' : ''}`;
								let statusLiberado = statusEtapasEnum.NAO_REALIZADO;

								if (item.isLiberadoParcial !== undefined) {
									statusLiberado = item.isLiberadoParcial ? 'parcial' : statusLiberado;
								} else {
									statusLiberado = item.liberadoParcial ? 'parcial' : statusLiberado;
								}

								if (item.isLiberadoTotal !== undefined) {
									statusLiberado = item.isLiberadoTotal ? 'realizado' : statusLiberado;
								} else {
									statusLiberado = item.liberadoTotal ? 'realizado' : statusLiberado;
								}

								if (item.existeNConfPendente) {
									cardClass += ' naoconformidade';
								}
								return (
									<Row key={item.id}>
										<Col>
											<Card className={cardClass} style={{ minHeight: '140px' }}>
												<CardBody>
													<Row>
														<Col>
															<Row style={{ minHeight: '90px' }}>
																<Col
																	xl={5}
																	className="detalhes-exame"
																	onClick={() => {
																		onItemClick(item);
																	}}
																>
																	<CardText>
																		<div>
																			<span className="registro-civil">
																				{item.prontuario} - {item.paciente}
																			</span>
																		</div>
																	</CardText>

																	{item.nrExame && item.nrExame !== '' && (
																		<CardText>
																			<strong>
																				<IntlMessage id="dashboards.examDetails.numberExam" />{' '}
																			</strong>
																			{item.nrExame}
																		</CardText>
																	)}

																	{item.dataNascimento && (
																		<CardText>
																			<strong>
																				<IntlMessage id="dashboards.examDetails.birthDate" />{' '}
																			</strong>
																			{item.dataNascimento} -{' '}
																			{calcIdade(item.dataNascimento)} |{' '}
																			<strong>
																				<IntlMessage id="dashboards.examDetails.sex" />{' '}
																			</strong>
																			{mapGenero(item.sexo)}
																		</CardText>
																	)}
																</Col>
																<Col
																	onClick={() => {
																		onItemClick(item);
																	}}
																>
																	{item.pacienteNomeSocial &&
																		item.pacienteNomeSocial !== '' && (
																			<CardText>
																				<strong>
																					<IntlMessage id="dashboards.examDetails.socialName" />{' '}
																				</strong>
																				{item.pacienteNomeSocial}
																			</CardText>
																		)}

																	<CardText>
																		<strong>
																			<IntlMessage id="dashboards.examDetails.exam" />{' '}
																		</strong>{' '}
																		{item.exame}
																	</CardText>
																	{item.laudoAnterior !== null &&
																		item.laudoAnterior > 0 && (
																			<CardText>
																				<strong>
																					<IntlMessage id="dashboards.examDetails.previousExamNumber" />{' '}
																				</strong>
																				{item.numeroExameAnterior}
																			</CardText>
																		)}
																	{item.dataPedido &&
																		item.dataPedido !== '' && (
																			<CardText>
																				<strong>
																					<IntlMessage id="dashboards.examDetails.orderDate" />{' '}
																				</strong>
																				{item.dataPedido}
																			</CardText>
																		)}

																	{item.numeroExamesCriticos > 0 && (
																		<div>
																			<UncontrolledTooltip
																				placement="left"
																				target={`iconeQtdExterno_${item.id}`}
																			>
																				<strong>
																					<IntlMessage id="dashboards.examDetail.previousExams" />{' '}
																					{item.numeroExamesCriticos}
																				</strong>
																			</UncontrolledTooltip>
																			<CardText
																				className="texto-critico"
																				id={`iconeQtdExterno_${item.id}`}
																			>
																				<strong>
																					<IntlMessage id="dashboards.examDetails.patientCriticalReport" />
																				</strong>
																			</CardText>
																		</div>
																	)}
																</Col>
																<Col
																	onClick={() => {
																		onItemClick(item);
																	}}
																>
																	<CardText>
																		<strong>
																			<IntlMessage id="dashboards.examDetails.requestingDoctor" />{' '}
																		</strong>
																		{item.medico}
																	</CardText>
																	{item.pedido && item.pedido !== '' && (
																		<CardText>
																			<strong>
																				<IntlMessage id="dashboards.examDetails.examRequest" />{' '}
																			</strong>
																			{item.pedido}
																		</CardText>
																	)}
																	{item.dataEntregaPrevista &&
																		item.dataEntregaPrevista !== '' && (
																			<CardText>
																				<strong>
																					<IntlMessage id="dashboards.examDetails.expectedDeliveryDate" />{' '}
																				</strong>
																				{item.dataEntregaPrevista}
																			</CardText>
																		)}
																	{item.dataLiberacao && item.dataLiberacao !== '' &&
																	(
																		<CardText>
																			<strong>
																				<IntlMessage id="dashboards.general.performingPhysician"/>{': '}
																			</strong>
																			{item.medicoLiberacao}
																		</CardText>
																	)}
																	{item.nrExameExterno &&
																		item.nrExameExterno !== '' && (
																			<div>
																				<UncontrolledTooltip
																					placement="left"
																					target={`iconeQtdExterno_${item.id}`}
																				>
																					<strong>
																						<IntlMessage id="dashboards.examDetails.block" />{' '}
																					</strong>
																					{item.qtdBlocoExterno}
																					<br />
																					<strong>
																						<IntlMessage id="dashboards.examDetails.blade" />{' '}
																					</strong>
																					{item.qtdLaminaExterno}
																				</UncontrolledTooltip>
																				<CardText
																					id={`iconeQtdExterno_${item.id}`}
																				>
																					<strong>
																						<IntlMessage id="dashboards.examDetails.externalExam" />{' '}
																					</strong>
																					{item.nrExameExterno}
																				</CardText>
																			</div>
																		)}
																</Col>
															</Row>
															<Row
																onClick={() => {
																	onItemClick(item);
																}}
															>
																<div className="col-auto">
																	<div className="etapas-lista">
																		{item.etapas !== null &&
																			item.etapas !== undefined &&
																			item.etapas.length > 0 &&
																			item.etapas.map((etapa) => {
																				const status =
																					etapa.status ===
																						statusEtapasEnum.NAO_CONFORMIDADE &&
																					etapa.etapaFinalizada
																						? 'naoconformidade-indicativa'
																						: etapa.status;

																				return (
																					etapa.status !==
																						statusEtapasEnum.NAO_APLICAVEL && (
																						<span
																							key={`${etapa.etapa}_${item.id}`}
																							className="tag-etapa"
																						>
																							<Badge
																								id={`${etapa.etapa}_${item.id}`}
																								className={status}
																							>
																								{etapa.etapa ===
																								etapasEnum.NOTAS
																									? labelNotas
																									: getTranslate(
																											retornaEtapaFormatada(
																												etapa.etapa
																											)
																									  )}
																							</Badge>
																							<UncontrolledTooltip
																								placement="top"
																								target={`${etapa.etapa}_${item.id}`}
																							>
																								{getTranslate(
																									retornaStatusFormatado(
																										etapa.status
																									)
																								)}
																							</UncontrolledTooltip>
																						</span>
																					)
																				);
																			})}
																		<Badge className={statusLiberado}>
																			<IntlMessage id="dashboards.examDetails.released" />
																		</Badge>
																	</div>
																</div>
															</Row>
															<div className="icones-exame-lista">
															<div onClick={() => {
																	toggleModalInfoLaudo(item.laudo);
																	// setModalInfoLaudo(true);
																	// onItemClick(item);
																}}>
															<IconInfoCard
																id={`mv-basico-aviso_visualizar`}
																icon="mv-basico-detalhes"
																color=""
																text={getTranslate(
																	'dashboards.examDetail.viewadditionalinfo'
																)}
																/>

																</div>
																{item.statusAcordo === 'atrasado' ? (
																	<IconInfoCard
																		id={`iconeAcordo_${item.id}`}
																		icon="pi pi-history"
																		color="#ecc412"
																		text={getTranslate(
																			'menu.statusServiceAgreementYellow'
																		)}
																	/>
																) : (
																	<div />
																)}
																{item.statusAcordo === 'em_dia' ? (
																	<IconInfoCard
																		id={`iconeAcordo_${item.id}`}
																		icon="pi pi-history"
																		color="#00AA55"
																		text={getTranslate(
																			'menu.statusServiceAgreementGreen'
																		)}
																	/>
																) : (
																	<div />
																)}
																{item.statusAcordo === 'vencido' ? (
																	<IconInfoCard
																		id={`iconeAcordo_${item.id}`}
																		icon="pi pi-history"
																		color="#ee0001"
																		text={getTranslate(
																			'menu.statusServiceAgreementRed'
																		)}
																	/>
																) : (
																	<div />
																)}
																{item.existeBlocoCriado &&
																	item.etapas.find(
																		(et) =>
																			et.etapa === etapasEnum.CONCLUSAO &&
																			et.status !== statusEtapasEnum.REALIZADO
																	) && (
																		<IconInfoCard
																			id={`iconeRequisicao_${item.id}`}
																			icon="fas fa-eye-dropper"
																			color="#1385be"
																			text={getTranslate(
																				'dashboards.examDetail.protocolRequestAvailable'
																			)}
																		/>
																	)}
																{item.habilitadoCertificacao && (
																	<IconInfoCard
																		id={`icone-certificacao-${item.id}`}
																		icon="fas fa-certificate"
																		color={
																			item.certificado ? '#7ec044' : '#dc3545'
																		}
																		text={
																			item.certificado
																				? getTranslate(
																						'dashboards.examDetail.certificate'
																				  )
																				: getTranslate(
																						'dashboards.examDetail.noCertificate'
																				  )
																		}
																	/>
																)}
																{item.totalExamesEmAberto > 0 && (
																	<IconInfoCard
																		id={`iconeTotalExames_${item.id}`}
																		icon="fas fa-flask"
																		color="#32323d"
																		text={getTranslate(
																			'dashboards.examDetails.openExams'
																		)}
																		badge={item.totalExamesEmAberto}
																	/>
																)}
																{item.laudoAnterior !== null &&
																	item.laudoAnterior > 0 && (
																		<IconInfoCard
																			id={`iconeLaudoAnterior_${item.id}`}
																			icon="fas fa-link"
																			color="#32323d"
																			text={getTranslate(
																				'dashboards.examDetails.examLinked'
																			)}
																		/>
																	)}
																{item.alertaUrgenciaEntrega &&
																	item.dataEntrega === '' && (
																		<IconInfoCard
																			id={`dataEntregaProximaItem_${item.id}`}
																			icon="fas fa-hourglass-end"
																			color="#dc3545"
																			text={getTranslate(
																				'dashboards.examDetails.nextDeliveryDate'
																			)}
																		/>
																	)}
																{item.critico && item.dataEntrega === '' && (
																	<IconInfoCard
																		id={`criticoIconTooltip_${item.id}`}
																		icon="fas fa-plus-circle"
																		color="#dc3545"
																		text={getTranslate(
																			'dashboards.examDetails.criticalReport'
																		)}
																	/>
																)}
																{item.urgente && item.dataEntrega === '' && (
																	<IconInfoCard
																		id={`urgenteIconTooltip_${item.id}`}
																		icon="fas fa-exclamation-triangle"
																		color="#dc3545"
																		text={getTranslate(
																			'dashboards.examDetails.urgentExam'
																		)}
																	/>
																)}
																{item.dataLiberacao !== null &&
																	item.dataLiberacao !== '' &&
																	item.dataEntrega !== null &&
																	item.dataEntrega !== '' && (
																		<IconInfoCard
																			id={`entregueIconTooltip_${item.id}`}
																			icon="fas fa-check-circle"
																			color="#7ec044"
																			text={
																				getTranslate(
																					'dashboards.examDetails.examDeliveredIn'
																				) + `${item.dataEntrega}`
																			}
																		/>
																	)}
																{item.termoNConfImpresso && (
																	<IconInfoCard
																		id={`termoNConfImpresso_${item.id}`}
																		icon="fas fa-file-signature"
																		color="#dc3545"
																		text={getTranslate(
																			'dashboards.examDetails.printedTermofConsent'
																		)}
																	/>
																)}

																{item.dataLiberacao !== null &&
																item.dataLiberacao !== '' &&
																item.dataEntrega !== null &&
																item.dataEntrega !== '' &&
																item.entreguePeloPortal && (
																	<IconInfoCard
																		id={`entregue_portal_${item.id}`}
																		//icon="mv-basico-autorizar_cota"
																		icon="fas fa-clipboard-check"
																		color="#7ec044"
																		text={
																			getTranslate('dashboards.examDetails.reportDeliveredPortal')
																			+ `${item.dataEntrega}`
																		}
																	/>
																)}

																<ListagemActionsComponent
																	showModalEncaminhar={modalEncaminhar}
																	toggleModalEncaminhar={() => {
																		setModalEncaminhar(!modalEncaminhar);
																		setLaudo(item.laudo);
																	}}
																	acessoPermitido={acessoPermitido}
																	usuario={usuario}
																	toggleModal={toggleModal}
																	handleModalCID={handleModalCID}
																	openModalEntrega={openModalEntrega}
																	toggleModalImprimir={toggleModalImprimir}
																	toggleModalEtiquetas={toggleModalEtiquetas}
																	toggleModalObservacoes={
																		toggleModalObservacoes
																	}
																	toggleModalRequisicaoImuno={
																		toggleModalRequisicaoImuno
																	}
																	toggleModalRequisicaoCongelacao={
																		toggleModalRequisicaoCongelacao
																	}
																	toggleModalEmail={toggleModalEmail}
																	toggleModalInfoLaudo={toggleModalInfoLaudo}
																	liberarLaudo={liberarLaudo}
																	acessos={acessos}
																	item={item}
																	handleModalCancelamento={
																		handleModalCancelamento
																	}
																	commonActions={commonActions}
																/>
															</div>
														</Col>
													</Row>
												</CardBody>
											</Card>
										</Col>
									</Row>
								);
							})}
						</div>
					</InfiniteScroll>
				)}
			</div>
		</Col>
	);
}

const mapStateToProps = (state) => ({
	modalCertificacao: state.certificacao.showModal,
	usuario: state.usuario,
	detalhes: state.commonReducer.detalhes,
	exibirChecklistRecebimento:
		state.recebimentoMaterial.exibirChecklistRecebimento,
	textoProtocoloEntregaMaterial:
		state.commonReducer.textoProtocoloEntregaMaterial,
	altura: state.commonReducer.altura,
	modalEntrega: state.commonReducer.modalEntrega,
	modalFaturamento: state.commonReducer.modalFaturamento,
	modalImprimir: state.commonReducer.modalImprimir,
	modalObservacoes: state.commonReducer.modalObservacoes,
	modalRequisicaoImuno: state.commonReducer.modalRequisicaoImuno,
	modalLiberarParcialmente: state.modalLiberacaoParcial,
});

const mapDispacthToProps = (dispatch) => ({
	commonActions: bindActionCreators(commonActionsReducer, dispatch),
	modalLiberarParcialmenteAction: bindActionCreators(
		modalLiberacaoParcialmenteAction,
		dispatch
	),
	modalLiberarLaudoAction: bindActionCreators(
		modalLiberarLaudoAction,
		dispatch
	),
	certificacaoActions: bindActionCreators(certificacaoActionsReducer, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispacthToProps
)(ListagemCommonContainer);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/listagem.common.container.jsx